import { Button } from "@/components/ui/button"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import Menu from "./menu"
import Logo from "@/components/logo"
import BurgerIcon from "@/components/icons/burger"
import { useState } from "react"

export function MenuMobile() {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost">
          <BurgerIcon />
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <SheetHeader>
          <SheetTitle>
            <Logo />
          </SheetTitle>
        </SheetHeader>
        <div className="pt-5 flex flex-grow">
          <Menu onClick={() => setOpen(false)} />
        </div>
      </SheetContent>
    </Sheet>
  )
}
